// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".documents__multiselect[data-v-79fff1d8] {\n  min-width: 15rem;\n}", ""]);
// Exports
module.exports = exports;
